import { Navigate } from 'react-router-dom';
import type { ReactNode } from 'react';
import { useUser } from '../../context/UserContext';

/**
 * Garde « admin OU valideur des paiements (liste réglée dans Paiements > Paramètres) » —
 * pour le seul écran « À valider », qui doit rester accessible à un valideur
 * non administrateur. Les autres écrans de paiements, « En cours » compris, sont
 * réservés aux administrateurs et passent par RequireAdmin. À utiliser après
 * RequireAuth.
 *
 * Le périmètre de ce que l'écran MONTRE n'est pas décidé ici : le serveur filtre
 * (tout pour un administrateur, ses seules demandes pour un valideur).
 */
export function RequireAdminOrValidator({ children }: { children: ReactNode }) {
  const { user } = useUser();
  if (user === undefined) return null;
  if (!user || (user.role !== 'admin' && !user.is_payment_validator)) {
    return <Navigate to="/" replace />;
  }
  return <>{children}</>;
}
